const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** Allowed chars in appointment ids (cuid, appointment-…, uuid, etc.). */
const APPOINTMENT_ID_RE = /^[a-zA-Z0-9_-]{10,80}$/;

export function normalizeQrPayload(text: string): string {
  return text
    .trim()
    .replace(/^\uFEFF/, '')
    .replace(/\s+/g, '');
}

export function isPlausibleAppointmentId(value: string): boolean {
  if (!value || value.length < 10 || value.length > 80) return false;
  return APPOINTMENT_ID_RE.test(value);
}

/** Extract appointment id from QR payload (URL or raw id). */
export function parseAppointmentIdFromQr(text: string): string | null {
  const trimmed = normalizeQrPayload(text);
  if (!trimmed) return null;

  // Frontoffice confirmation URL: …/appointment/{id}
  const pathMatch = trimmed.match(/\/appointment\/([^/?#\s]+)/i);
  if (pathMatch?.[1]) {
    const id = decodeURIComponent(pathMatch[1]).trim();
    if (isPlausibleAppointmentId(id)) return id;
  }

  // Backoffice-style path (manual paste)
  const adminPathMatch = trimmed.match(/\/appointments\/([^/?#\s]+)/i);
  if (adminPathMatch?.[1]) {
    const id = decodeURIComponent(adminPathMatch[1]).trim();
    if (isPlausibleAppointmentId(id)) return id;
  }

  if (isPlausibleAppointmentId(trimmed)) return trimmed;

  // UUID embedded in longer text (legacy qr_codes.code field scans)
  const uuidInText = trimmed.match(UUID_RE);
  if (uuidInText?.[0] && isPlausibleAppointmentId(uuidInText[0])) return uuidInText[0];

  // appointment-{timestamp}-… pattern anywhere in payload
  const appointmentToken = trimmed.match(/appointment-\d+-[a-z0-9]+/i);
  if (appointmentToken?.[0] && isPlausibleAppointmentId(appointmentToken[0])) {
    return appointmentToken[0];
  }

  return null;
}
